module.exports = __webpack_public_path__ + "static/media/resumo-edital.b20455f3.svg";